import { mapActions } from 'vuex';
import amountInfo from '@/components/wallet/amount-info/amount-info.vue';
import stateIcon from '@/components/wallet/pending-requests/state-icon/state-icon.vue';
import { dateToString } from '@/utils/helpers';
import loaderMixin from '@/mixins/loader';

const TYPE_CHECK = 1;
const TYPE_ACH = 2;
const TYPE_COINBASE = 4;
const TYPE_BANK_TRANSFER = 5;

export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    request: {
      type: Object,
      required: true,
    },
    isDeposit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAch() {
      return this.request.type === TYPE_ACH;
    },
    isCheck() {
      return this.request.type === TYPE_CHECK;
    },
    isCoinbase() {
      return this.request.type === TYPE_COINBASE;
    },
    isBankTransfer() {
      return this.request.type === TYPE_BANK_TRANSFER;
    },
    requestDate() {
      return dateToString(this.request.date || this.request.dateCreated);
    },
    paymentMethod() {
      if (!this.request) return '';

      switch (this.request.type) {
        case TYPE_ACH:
          return 'ACH';
        case TYPE_CHECK:
          return 'Check';
        case TYPE_COINBASE:
          return 'USD Coin';
        case TYPE_BANK_TRANSFER:
          return 'Bank Transfer';
        default:
          return '';
      }
    },
  },
  components: {
    amountInfo,
    stateIcon,
  },
  methods: {
    ...mapActions('wallet', ['cancelWithdrawal']),
    ...mapActions('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']),
    onCancel() {
      const payload = {
        withdrawalId: this.request.withdrawalId,
      };
      this.loaderAdd();
      this.cancelWithdrawal(payload)
        .then(() => this.loaderRemove())
        .then(() => this.setSuccessSideNotification('Your withdrawal has been cancelled.'))
        .then(() => this.$emit('success'))
        .catch(() => {
          this.loaderRemove();
          this.setErrorSideNotification('Operation failed.');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-request/pending-request.js